module.exports = __webpack_public_path__ + "img/ico_link-area01.fb461e27.svg";